import {useState} from 'react';
import {gen, rng} from 'utils/rng';

const CHARACTERS =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const LENGTH = CHARACTERS.length;

const randomId = (length: number, seed?: number) =>
    Array(length)
        .fill(length)
        .map(
            (_, index) =>
                CHARACTERS[
                    rng(
                        gen(
                            (seed || Math.floor(Math.random() * 100_000)) +
                                index,
                        ),
                        LENGTH,
                    )
                ],
        )
        .join('');

export type LayoutType = 'sideBySide' | 'stacked';

const useId = (): string => {
    const [id] = useState(() => randomId(8));

    return id;
};

export default useId;
